import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/client";

export default function LoginPage({ onLogin }) {
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "VIEWER",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      if (mode === "login") {
        const res = await apiClient.post("/auth/login", {
          email: form.email,
          password: form.password,
        });
        const { token, user } = res.data;
        onLogin(user, token);
        navigate("/");
      } else {
        const res = await apiClient.post("/auth/signup", {
          firstName: form.firstName,
          lastName: form.lastName,
          email: form.email,
          password: form.password,
          role: form.role,
        });
        setMessage(res.data.message || "Signup request sent");
        setForm({ firstName: "", lastName: "", email: "", password: "", role: "VIEWER" });
      }
    } catch (err) {
      const msg = err.response?.data?.error || err.message;
      setError(msg);
    }
  };

  return (
    <div className="page page-narrow">
      <div className="card">
        <h2 style={{ marginBottom: "8px" }}>
          {mode === "login" ? "כניסה למערכת" : "הרשמה"}
        </h2>
        <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: "0 0 var(--space-lg) 0" }}>
          {mode === "login" ? "הזן אימייל וסיסמה" : "מילוי פרטים לבקשת הרשמה"}
        </p>

        <div className="tabs">
          <button
            type="button"
            onClick={() => setMode("login")}
            className={mode === "login" ? "active" : ""}
            disabled={mode === "login"}
          >
            התחברות
          </button>
          <button
            type="button"
            onClick={() => setMode("signup")}
            className={mode === "signup" ? "active" : ""}
            disabled={mode === "signup"}
          >
            הרשמה
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          {mode === "signup" && (
            <>
              <div className="field">
                <label className="label">שם פרטי</label>
                <input
                  className="input"
                  name="firstName"
                  value={form.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="field">
                <label className="label">שם משפחה</label>
                <input
                  className="input"
                  name="lastName"
                  value={form.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </>
          )}

          <div className="field">
            <label className="label">אימייל</label>
            <input
              className="input"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="field">
            <label className="label">סיסמה</label>
            <input
              className="input"
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          {mode === "signup" && (
            <div className="field">
              <label className="label">תפקיד מבוקש</label>
              <select
                className="select"
                name="role"
                value={form.role}
                onChange={handleChange}
              >
                <option value="VIEWER">צופה</option>
                <option value="EDITOR">עורך</option>
                <option value="ADMIN">מנהל</option>
              </select>
            </div>
          )}

          <button type="submit" className="btn btn-primary" style={{ marginTop: "8px", width: "100%" }}>
            {mode === "login" ? "התחברות" : "שליחת בקשת הרשמה"}
          </button>
        </form>

        {message && <p className="message-success" style={{ marginTop: "var(--space-md)", marginBottom: 0, color: "var(--success, #16a34a)", fontWeight: 500 }}>{message}</p>}
        {error && <p className="message-error" style={{ marginTop: "var(--space-md)", marginBottom: 0 }}>{error}</p>}
      </div>
    </div>
  );
}
